<template>
  <el-dropdown size="small" class="d2-mr">
    <span class="btn-text">
      {{info.nickname ? `你好, ${info.nickname} ` : '未登录'}}
      <d2-icon name="angle-down" />
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item @click.native="updateProfile">
        <d2-icon name="user-circle-o" />个人资料
      </el-dropdown-item>
      <el-dropdown-item @click.native="updatePass">
        <d2-icon name="dot-circle-o" />修改密码
      </el-dropdown-item>
      <el-dropdown-item @click.native="logOff">
        <d2-icon name="power-off" class="d2-mr-5" />退出登录
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  computed: {
    ...mapState('d2admin/user', ['info'])
  },
  methods: {
    ...mapActions('d2admin/account', ['logout']),
    /**
     * @description 登出
     */
    logOff () {
      this.logout({
        confirm: true
      })
    },
    updateProfile () {
      this.$router.push({ path: '/my/profile' })
    },
    updatePass () {
      this.$router.push({ path: '/my/password' })
    }
  }
}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
